(function () {
  'use strict';

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(value || '').trim());
  }

  function initQuiz(root) {
    if (!root || root.dataset.dmqReady === '1') return;
    root.dataset.dmqReady = '1';

    var storageKey = root.dataset.storageKey || 'diy-match-quiz';
    var googleUrl = (root.dataset.googleScriptUrl || '').trim();

    var overlay = root.querySelector('[data-dmq-overlay]');
    var dialog = root.querySelector('.dmq__dialog');
    var launcher = root.querySelector('[data-dmq-launcher]');
    var formView = root.querySelector('[data-dmq-view="form"]');
    var resultView = root.querySelector('[data-dmq-view="result"]');
    var emailInput = root.querySelector('[data-dmq-email]');
    var emailError = root.querySelector('[data-dmq-email-error]');
    var optionError = root.querySelector('[data-dmq-option-error]');
    var submitBtn = root.querySelector('[data-dmq-submit]');
    var resultPanels = root.querySelectorAll('[data-dmq-result]');
    var productCards = root.querySelectorAll('[data-dmq-product]');

    function scrollDialogTop() {
      if (dialog) dialog.scrollTop = 0;
    }

    function readCache() {
      try {
        var raw = localStorage.getItem(storageKey);
        return raw ? JSON.parse(raw) : null;
      } catch (e) {
        return null;
      }
    }

    function writeCache(data) {
      try {
        localStorage.setItem(storageKey, JSON.stringify(data));
      } catch (e) {}
    }

    function clearCache() {
      try {
        localStorage.removeItem(storageKey);
      } catch (e) {}
    }

    function trackBannerClick() {
      var payload = { site: 'UK', module: '运营资源位', clickName: 'quizUK' };
      if (window.jQuery) {
        window.jQuery.ajax({
          type: 'get',
          dataType: 'json',
          url: 'https://qn.htvront.com/htvront-blindBox/click',
          data: payload,
        });
        return;
      }
      try {
        var qs = Object.keys(payload)
          .map(function (key) {
            return encodeURIComponent(key) + '=' + encodeURIComponent(payload[key]);
          })
          .join('&');
        fetch('https://qn.htvront.com/htvront-blindBox/click?' + qs, {
          method: 'GET',
          mode: 'no-cors',
          credentials: 'omit',
        }).catch(function () {});
      } catch (e) {}
    }

    function openModal() {
      if (!overlay) return;
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.classList.add('overflow-hidden');
      syncFromCache();
    }

    function closeModal() {
      if (!overlay) return;
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('overflow-hidden');
    }

    function showForm() {
      if (formView) formView.hidden = false;
      if (resultView) resultView.hidden = true;
    }

    function getPanelDiscount(panel) {
      return panel ? panel.getAttribute('data-dmq-discount') || '' : '';
    }

    function showResult(answerKey) {
      if (formView) formView.hidden = true;
      if (resultView) resultView.hidden = false;
      resultPanels.forEach(function (panel) {
        panel.hidden = (panel.getAttribute('data-dmq-result') || '') !== String(answerKey);
      });
      scrollDialogTop();
    }

    function selectedOption() {
      return root.querySelector('input[name="dmq-answer"]:checked');
    }

    function syncFromCache() {
      var cache = readCache();
      if (cache && cache.answerKey) {
        if (emailInput && cache.email) emailInput.value = cache.email;
        showResult(cache.answerKey);
        return;
      }
      showForm();
    }

    function setFieldError(show) {
      if (!emailInput || !emailError) return;
      emailInput.classList.toggle('is-error', !!show);
      emailError.classList.toggle('is-visible', !!show);
    }

    function setOptionError(show) {
      if (!optionError) return;
      optionError.classList.toggle('is-visible', !!show);
    }

    function sendToGoogleSheets(payload) {
      if (!googleUrl) {
        console.warn('[DIY Match] Google Script URL 未配置');
        return;
      }
      // Apps Script + 浏览器跨域：用 text/plain，避免 application/json 预检失败
      // 参考：https://developers.google.com/apps-script/guides/web
      var body = JSON.stringify(payload);
      fetch(googleUrl, {
        method: 'POST',
        mode: 'no-cors',
        redirect: 'follow',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: body,
      }).catch(function (err) {
        console.error('[DIY Match] Sheets error:', err);
      });
    }

    function handleSubmit() {
      var email = emailInput ? emailInput.value.trim() : '';
      var option = selectedOption();
      var emailOk = validEmail(email);
      setFieldError(!emailOk);
      setOptionError(!option);
      if (!emailOk || !option) return;

      var answerKey = option.value;
      var answerLabel = option.getAttribute('data-label') || answerKey;
      var panel = null;
      for (var i = 0; i < resultPanels.length; i++) {
        if (resultPanels[i].getAttribute('data-dmq-result') === answerKey) {
          panel = resultPanels[i];
          break;
        }
      }
      var discountCode = getPanelDiscount(panel);
      var now = new Date();
      var submitTime =
        now.toLocaleDateString() +
        ' ' +
        now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit', hour12: false });

      writeCache({
        email: email,
        answerKey: answerKey,
        answerLabel: answerLabel,
        discountCode: discountCode,
        timestamp: now.toISOString(),
        submitTime: submitTime,
      });

      sendToGoogleSheets({
        email: email,
        answerKey: answerKey,
        answerLabel: answerLabel,
        submitTime: submitTime,
      });

      showResult(answerKey);
    }

    /* ===== 变体下拉：参考 thousand-commodity-variants ===== */
    function closeAllVariantUls(scope) {
      (scope || root).querySelectorAll('.dmq-variant-selects ul').forEach(function (ul) {
        ul.classList.remove('is-open');
      });
    }

    function applyPackageValue(card, li) {
      if (!card || !li || li.classList.contains('is-disabled')) return;

      var variantId = li.getAttribute('data-variant-id');
      var imgSrc = li.getAttribute('data-image-src');
      var price = li.getAttribute('data-price') || '';
      var compare = li.getAttribute('data-compare-at-price') || '';
      var available = li.getAttribute('data-available') === 'true';
      var productUrl = card.getAttribute('data-product-url') || '';
      var atcLabel = card.getAttribute('data-atc-label') || 'Add To Cart';
      var soldoutLabel = card.getAttribute('data-soldout-label') || 'Sold Out';
      var labelText = (li.querySelector('span') && li.querySelector('span').textContent) || '';

      var list = li.parentElement;
      if (list) {
        list.querySelectorAll('.dmq-package-value').forEach(function (el) {
          el.classList.toggle('is-active', el === li);
        });
        var h3 = list.previousElementSibling;
        if (h3 && h3.tagName === 'H3') h3.textContent = labelText.trim();
      }

      var priceEl = card.querySelector('[data-dmq-price]');
      var compareEl = card.querySelector('[data-dmq-compare]');
      var imgEl = card.querySelector('[data-dmq-product-image]');
      if (priceEl) priceEl.textContent = price;
      if (compareEl) {
        if (compare && compare !== price && compare !== '$0.00' && compare !== '') {
          compareEl.textContent = compare;
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (imgEl && imgSrc) imgEl.src = imgSrc;

      var href = productUrl + (productUrl.indexOf('?') > -1 ? '&' : '?') + 'variant=' + variantId;
      card.querySelectorAll('[data-dmq-product-link]').forEach(function (a) {
        a.href = href;
      });

      // 与 thousand-commodity-variants 一致：通过 product-id 找到表单并更新 id
      var productId = card.getAttribute('data-product-id');
      var productIdInput = card.querySelector('input[name="product-id"][value="' + productId + '"]');
      var formRoot = productIdInput ? productIdInput.parentElement : card.querySelector('.product-form');
      if (formRoot) {
        var idInput = formRoot.querySelector('input[name="id"]');
        var submitBtnEl = formRoot.querySelector('button[type="submit"]') ||
          card.querySelector('#campaign_' + productId);
        var textEl = submitBtnEl && submitBtnEl.querySelector('.t');
        if (idInput) {
          idInput.value = variantId;
          idInput.removeAttribute('disabled');
        }
        if (submitBtnEl) {
          submitBtnEl.disabled = !available;
          if (textEl) textEl.textContent = available ? atcLabel : soldoutLabel;
        }
      }

      closeAllVariantUls(card);
    }

    function initProductCard(card) {
      // 打开/关闭下拉
      card.querySelectorAll('.dmq-variant-selects').forEach(function (box) {
        box.addEventListener('click', function (e) {
          if (e.target.closest('li')) return;
          e.stopPropagation();
          var ul = box.querySelector('ul');
          var wasOpen = ul && ul.classList.contains('is-open');
          closeAllVariantUls(root);
          if (ul && !wasOpen) ul.classList.add('is-open');
        });
      });

      // Package / 变体项
      card.querySelectorAll('.dmq-package-value').forEach(function (li) {
        li.addEventListener('click', function (e) {
          e.stopPropagation();
          applyPackageValue(card, li);
        });
      });

      // Color / 其它 option：过滤 package 列表
      card.querySelectorAll('.dmq-color-options li').forEach(function (li) {
        li.addEventListener('click', function (e) {
          e.stopPropagation();
          if (li.classList.contains('is-disabled')) return;
          var valText = ((li.querySelector('span') && li.querySelector('span').textContent) || '').trim();
          var list = li.parentElement;
          if (list) {
            list.querySelectorAll('li').forEach(function (el) {
              el.classList.toggle('is-active', el === li);
            });
            var h3 = list.previousElementSibling;
            if (h3 && h3.tagName === 'H3') h3.textContent = valText;
          }

          var packageValues = card.querySelectorAll('.dmq-package-value');
          packageValues.forEach(function (pv) {
            pv.classList.remove('is-show', 'is-active');
            var filter = (pv.getAttribute('data-filter-name') || '').trim();
            if (filter === valText) pv.classList.add('is-show');
          });
          var firstShow = card.querySelector('.dmq-package-value.is-show');
          if (firstShow) {
            firstShow.classList.add('is-active');
            applyPackageValue(card, firstShow);
          }
          closeAllVariantUls(card);
        });
      });

      // 初始化：点击第一个可见 package
      var first = card.querySelector('.dmq-package-value.is-show.is-active') ||
        card.querySelector('.dmq-package-value.is-show') ||
        card.querySelector('.dmq-package-value');
      if (first) applyPackageValue(card, first);
    }

    root.querySelectorAll('.dmq__option').forEach(function (card) {
      card.addEventListener('click', function () {
        var input = card.querySelector('input[type="radio"]');
        if (!input) return;
        input.checked = true;
        root.querySelectorAll('.dmq__option').forEach(function (c) {
          c.classList.toggle('is-selected', c === card);
        });
        setOptionError(false);
      });
    });

    productCards.forEach(initProductCard);

    document.addEventListener('click', function () {
      closeAllVariantUls(root);
    });

    if (submitBtn) submitBtn.addEventListener('click', handleSubmit);
    if (emailInput) {
      emailInput.addEventListener('input', function () {
        if (validEmail(emailInput.value)) setFieldError(false);
      });
    }

    root.querySelectorAll('[data-dmq-close]').forEach(function (btn) {
      btn.addEventListener('click', closeModal);
    });

    if (overlay) {
      overlay.addEventListener('click', function (e) {
        if (e.target === overlay || e.target.hasAttribute('data-dmq-backdrop')) closeModal();
      });
    }

    if (launcher) {
      launcher.addEventListener('click', function () {
        trackBannerClick();
        openModal();
      });
    }

    root.querySelectorAll('[data-dmq-retry]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        clearCache();
        root.querySelectorAll('input[name="dmq-answer"]').forEach(function (input) {
          input.checked = false;
        });
        root.querySelectorAll('.dmq__option').forEach(function (c) {
          c.classList.remove('is-selected');
        });
        showForm();
      });
    });

    root.addEventListener('click', function (e) {
      var copyBtn = e.target.closest('[data-dmq-copy]');
      if (!copyBtn || !root.contains(copyBtn)) return;
      e.preventDefault();
      var panel = copyBtn.closest('[data-dmq-result]');
      var codeEl = panel && panel.querySelector('[data-dmq-code]');
      var toast = panel && panel.querySelector('[data-dmq-copy-toast]');
      var code = (codeEl && codeEl.textContent) || getPanelDiscount(panel) || '';
      var done = function () {
        if (toast) {
          toast.classList.add('is-visible');
          setTimeout(function () {
            toast.classList.remove('is-visible');
          }, 1500);
        }
      };
      if (!code) return;
      if (navigator.clipboard && navigator.clipboard.writeText) {
        navigator.clipboard.writeText(code).then(done).catch(done);
      } else {
        done();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && overlay && overlay.classList.contains('is-open')) closeModal();
    });

    root.dmqOpen = openModal;
    root.dmqClose = closeModal;
    document.addEventListener('diy-match:open', openModal);
    if (window.location.hash === '#diy-match') openModal();
  }

  function boot() {
    document.querySelectorAll('[data-dmq-root]').forEach(initQuiz);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
